import { PartnerContactForm } from '@poinz/api';
import * as Yup from 'yup';

export const contactValidationSchema = (t: any) => {
  const shapeObject = {
    firstName: Yup.string().required(
      t('general.form.validation.genericRequired', { value: t('general.form.firstName') })
    ),
    lastName: Yup.string().required(
      t('general.form.validation.genericRequired', { value: t('general.form.lastName') })
    ),
    company: Yup.string().required(
      t('general.form.validation.genericRequired', { value: t('general.form.company') })
    ),
    phone: Yup.string().required(
      t('general.form.validation.genericRequired', { value: t('general.form.phoneNumber') })
    ),
    email: Yup.string()
      .email(t('general.form.validation.email'))
      .required(t('general.form.validation.genericRequired', { value: t('general.form.email') })),
    message: Yup.string().required(
      t('general.form.validation.genericRequired', { value: t('general.form.message') })
    )
  } as Record<keyof PartnerContactForm, any>;

  return Yup.object().shape(shapeObject);
};
